import React from "react";
import { Avatar, Box, Grid, Stack, Divider } from "@mui/material";
import { Sidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import { BsCaretUpFill, BsCaretDownFill } from "react-icons/bs";
import { Link } from "react-router-dom";
import { Routes, Route } from "react-router-dom";
import MyToolBar from "../components/MyToolBar";
import { useSelector } from "react-redux";
// import logo from './sidemenulogo.webp'
import logo from "./logo.png";
import logosm from "./logosm.png";
import { useLocation } from "react-router-dom";
import "./layout.css";
export default function Layout(props) {
  let user = useSelector((state) => state?.loginState?.auth);
  const [toggled, setToggled] = React.useState(false);
  const [isMinimize, setIsMinimize] = React.useState(false);
  const menuClasses = { icon: "ps-menu-icon" };
  const [broken, setBroken] = React.useState(
    window.matchMedia("(max-width: 800px)").matches
  );
  const location = useLocation();
  let hideProps = props?.menus?.filter((item) => item.to == location.pathname);
  hideProps = hideProps?.length > 0 ? hideProps[0] : {};
  //let permissions = user?.permissions?.filter((permisson) => permisson.includes(".view_"))
  const menuCss = {
    paddingLeft: 6,
    paddingRight: 6,
    height: "auto",
    fontSize: 14,
    borderRadius: 8,
    marginBottom: 10,
    color: "#4b5563",
    fontWeight: 500,
    color: "#756f6f",
  };
  const activeMenuCss = {
    color: "white",
  };
  function removeBaseUrl(url) {
    // Regular expression to match the base URL
    var baseUrlPattern = /^https?:\/\/[a-zA-Z0-9.-]+/;
    // Replace the base URL with an empty string
    var withport = url.replace(baseUrlPattern, "");

    return withport.replace(new RegExp(`.*?${"/"}`), "/").replace("/#", "");
  }
  const url = removeBaseUrl(window.location.href);

  React.useEffect(() => {
    setToggled(!broken);
  }, []);

  let submenus = [];
  const ResponsiveSideBar = ({ children }) => {
    if (broken) {
      // mobile side bar
      return (
        <>
          <Sidebar
            onBackdropClick={() => {
              setToggled(false);
              setIsMinimize(true);
            }}
            toggled={toggled}
            breakPoint="all"
          >
            {children}
          </Sidebar>
        </>
      );
    }
    //full width side bar
    return (
      <>
        <aside
          className="card-bg"
          style={{
            borderRadius: 8,
            minHeight: "98vh",
            padding: "10px",
            display: toggled ? "block" : "none1",
            maxWidth: toggled ? 250 : 100,
          }}
        >
          {children}
        </aside>
      </>
    );
  };
  // ispushsidebar
  const createMenu = () => {
    let permissions = user.permissions.map(
      (permission) => permission.split(".")[1]
    );
    if (props?.info) {
      console.info("Permissions", permissions);
    }
    if (!permissions.includes("*")) {
      permissions.push("*");
    }

    return props?.menus?.map((menu, j) => {
      if (menu?.owner?.includes(user.main_role)) {
        menu.label = menu.changeText;
      }
      if (menu?.hide) return <></>;
      if (menu?.permission && permissions.includes(menu?.permission)) {
        let subMenuActive = false;
        menu?.submenus?.map((submenu, i) => {
          if (!subMenuActive) {
            subMenuActive = url == submenu?.to;
          }
        });
        const active = window.location.href.includes(menu?.to) || subMenuActive;
        let css = active
          ? {
              ...menuCss,
              color: "#756f6f",
              borderRadius: 6,
              borderLeft: "4px solid green",
            }
          : menuCss;

        return (
          <>
            {!menu?.submenus && (
              <MenuItem style={css} component={<Link to={menu?.to} />} key={j}>
                <Stack direction="horizontal" gap={1} alignItems={"center"}>
                  <div
                    style={{ display: "flex", alignItems: "center" }}
                    className={
                      (active ? "ps-menu-icon-active" : "") +
                      (isMinimize ? " ps-menu-icon-big " : "") +
                      " ps-menu-icon"
                    }
                  >
                    {" "}
                    {menu?.icon}{" "}
                  </div>
                  {!isMinimize && (
                    <div
                      style={{ fontSize: 14 }}
                      dangerouslySetInnerHTML={{ __html: menu?.label }}
                    ></div>
                  )}
                </Stack>
              </MenuItem>
            )}
            {menu?.submenus && (
              <SubMenu
                {...props}
                style={{ ...css, paddingLeft: 0 }}
                label={!isMinimize ? menu?.label : null}
                icon={menu.icon}
              >
                {menu?.submenus?.map((submenu, i) => {
                  const subactive = url == submenu?.to;
                  let scss = subactive
                    ? {
                        ...menuCss,
                        color: "#756f6f",
                        borderRadius: 6,
                        borderLeft: "4px solid green",
                      }
                    : menuCss;
                  submenus.push(submenu);
                  if (submenu?.hide) return <></>;

                  return (
                    <>
                      <MenuItem
                        style={{ ...scss, marginLeft: 10 }}
                        component={<Link to={submenu?.to} />}
                        title={submenu?.label}
                        key={i}
                      >
                        <Stack direction="horizontal" gap={1}>
                          <div
                            className={
                              (subactive ? "ps-menu-icon-active" : "") +
                              " ps-menu-icon"
                            }
                          >
                            {submenu?.icon}
                          </div>
                          {!isMinimize && (
                            <div
                              dangerouslySetInnerHTML={{
                                __html: submenu?.label,
                              }}
                            ></div>
                          )}
                        </Stack>
                      </MenuItem>
                    </>
                  );
                })}
              </SubMenu>
            )}
          </>
        );
      }
    });
  };
  const createSideBar = () => (
    <>
      <ResponsiveSideBar>
        <Menu
          renderExpandIcon={({ open }) => (
            <span>{open ? <BsCaretUpFill /> : <BsCaretDownFill />}</span>
          )}
          rootStyles={{
            [`.${menuClasses.icon}`]: {
              color: "#344cff",
              borderRadius: 8,
            },
          }}
          menuItemStyles={{
            button: ({ level, active, disabled }) => {
              // only apply styles on first level elements of the tree
              if (level === 0)
                return {
                  color: disabled ? "#f5d9ff" : "black",
                  backgroundColor: active ? "white" : undefined,
                };
            },
          }}
        >
          {createHead()}
          {/* {createAvatar()} */}
          {createMenu()}
        </Menu>
      </ResponsiveSideBar>
    </>
  );

  const createAvatar = () => {
    return (
      <div
        style={{
          height: 100,
          textAlign: "center",
          padding: 4,
          marginBottom: 30,
        }}
      >
        <Avatar
          label={user?.first_name?.slice(0, 2)?.toUpperCase()}
          size="xlarge"
          shape="circle"
          image={user?.avatar}
        />
        <div className="mt-2">{user?.first_name}</div>
        <Divider />
      </div>
    );
  };
  const createHead = () => {
    return (
      <div
        style={{
          textAlign: "center",
          padding: 4,
          marginBottom: 30,
          fontSize: 18,
          fontWeight: 900,
        }}
      >
        {!isMinimize ? (
          <img src={logo} style={{ height: 30 }} />
        ) : (
          <img src={logosm} style={{ height: 30 }} />
        )}
        {/* <div className='mt-2'><span style={{ color: "#efcb64" }}>BG</span>LIVE</div> */}
      </div>
    );
  };

  const Margin = (hideBar) => {
    let body = (
      <>
        {!hideProps.hideSideBar && createSideBar()}
        <Box
          name="main"
          sx={{
            width: 1,
            minHeight: "100vh",
            overflow: "hidden", // Prevent horizontal scroll
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              height: "100vh", // Full viewport height
              overflow: "hidden",
            }}
          >
            <Box sx={{ flex: "0 0 auto" }}>
              {!hideProps.hideHeader && (
                <div style={{ marginBottom: 8 }}>
                  <MyToolBar
                    appName={props?.appName}
                    logo={props?.logo}
                    user={user}
                    onToggled={() => {
                      setToggled(!toggled);
                      setIsMinimize(!isMinimize);
                    }}
                    onLogout={props.onLogout}
                  />
                </div>
              )}
            </Box>
            <Box
              className="card-bg"
              sx={{
                flex: "1 1 auto",
                borderRadius: 4,
                overflow: "auto", // Allow scrolling for content
                maxHeight: "calc(100vh - 80px)", // Adjust based on header height
                padding: 2,
              }}
            >
              <Routes>
                {props?.menus?.map((menu, j) => (
                  <Route key={j} path={menu.to} element={menu.component} />
                ))}
                {submenus.map((submenu, j) => (
                  <Route
                    key={j}
                    path={submenu.to}
                    element={submenu.component}
                  />
                ))}

                {/* <Route path="*" element={<NoPage />} /> */}
              </Routes>
            </Box>
          </Box>
        </Box>
      </>
    );

    if (hideBar) return body;
    return (
      <Box sx={{ px: 1, pt: 1 }}>
        <Box display={"flex"} gap={1}>
          {body}
        </Box>
      </Box>
    );
  };

  return <>{Margin(hideProps.hideSideBar && hideProps.hideHeader)}</>;
}
